<template>
  <div id="app">
    <SeoHeadManager />
    <!-- Navbar -->
    <nav class="navbar navbar-expand-lg navbar-vampire fixed-top">
      <div class="container">
        <a class="navbar-brand" href="#">
          <i class="bi bi-moon-stars-fill me-2"></i>
          Vampiro: A Máscara
        </a>

        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
          style="border-color: var(--vampire-gold);">
          <span class="navbar-toggler-icon" style="filter: invert(1);"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav me-auto">
            <li class="nav-item">
              <a class="nav-link" href="#" @click.prevent="goToHome">
                <i class="bi bi-house-fill me-1"></i>
                Início
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#" @click.prevent="goToSectsIndex">
                <i class="bi bi-people-fill me-1"></i>
                Seitas
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#" @click.prevent="goToAllClans">
                <i class="bi bi-collection me-1"></i>
                Todos os Clãs
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#" @click.prevent="goToDisciplines">
                <i class="bi bi-bookmark-star me-1"></i>
                Disciplinas
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#" @click.prevent="goToRules">
                <i class="bi bi-journal-richtext me-1"></i>
                Regras
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#" @click.prevent="goToBooks">
                <i class="bi bi-book me-1"></i>
                Livros
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#" @click.prevent="goToGames">
                <i class="bi bi-controller me-1"></i>
                Jogos
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#" @click.prevent="goToStore">
                <i class="bi bi-shop-window me-1"></i>
                Loja
              </a>
            </li>
            <li class="nav-item" v-if="isLoggedIn">
              <a class="nav-link" href="#" @click.prevent="goToCharacterSheets">
                <i class="bi bi-file-earmark-person me-1"></i>
                Fichas
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#" @click.prevent="goToChat">
                <i class="bi bi-chat-dots me-1"></i>
                Chat
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#" @click.prevent="goToChronicles">
                <i class="bi bi-journal-richtext me-1"></i>
                Crônicas
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#" @click.prevent="goToMembership">
                <i class="bi bi-gem me-1"></i>
                Seja Membro!
              </a>
            </li>
          </ul>

          <!-- Área de Login/Logout -->
          <div class="d-flex align-items-center">
            <div v-if="!isLoggedIn">
              <button class="btn btn-vampire btn-sm" @click="showLoginModal = true">
                <i class="bi bi-box-arrow-in-right me-1"></i>
                Entrar
              </button>
            </div>

            <div v-else>
              <button class="btn btn-vampire btn-sm" type="button" @click.prevent="goToProfile">
                <i class="bi bi-person-circle me-1"></i>
                {{ userDisplayName }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>

    <!-- Conteúdo Principal -->
    <main class="container-fluid" style="margin-top: 80px; padding: 2rem 0;">
      <div v-if="registrationSuccessMessage" class="alert alert-success alert-vampire mx-auto mb-4" role="alert"
        style="max-width: 720px;">
        {{ registrationSuccessMessage }}
      </div>

      <!-- Página Inicial -->
      <div v-if="currentView === 'home'" class="fade-in">
        <div class="container">
          <div class="row align-items-center g-5 hero-section">
            <div class="col-lg-7">
              <p class="eyebrow mb-2 text-uppercase">Mundo das Trevas</p>
              <h1 class="sect-title mb-3">
                Desperte para as crônicas de Vampiro: A Máscara
              </h1>
              <p class="lead mb-4 text-muted-hero">
                Atualize-se sobre os movimentos políticos, eventos e rumores que moldam a Jyhad. Monte ficha de vampiro
                online, explore clãs e disciplinas de Vampiro A Máscara (V20 e V5) e mantenha seu coterie preparado para
                a próxima crônica.
              </p>
              <div class="d-flex flex-wrap gap-3">
                <button class="btn btn-vampire" type="button" @click.prevent="goToAllClans">
                  <i class="bi bi-collection-fill me-2"></i>
                  Explorar Clãs
                </button>
                <button class="btn btn-outline-light" type="button" @click.prevent="goToCharacterSheets">
                  <i class="bi bi-file-earmark-plus me-2"></i>
                  Criar Ficha
                </button>
              </div>
            </div>
            <div class="col-lg-5">
              <div class="nightfall-card">
                <div class="nightfall-card-header">
                  <span class="badge bg-danger text-uppercase">Boletim da Camarilla</span>
                  <span class="text-muted small">Atualizado há {{ featuredUpdate }}</span>
                </div>
                <p class="nightfall-card-title">Príncipe de São Paulo convoca conclave emergencial</p>
                <p class="text-muted small mb-0">
                  A paz frágil com os Anarquistas treme após rumores de que um primogênito desapareceu. Prepare sua
                  crônica para
                  disputas de poder e decisões difíceis.
                </p>
                <button class="btn btn-link text-decoration-none mt-3 px-0" type="button"
                  @click="openNews(newsItems[0])">
                  Ler detalhes <i class="bi bi-arrow-right-short"></i>
                </button>
              </div>
            </div>
          </div>

          <section class="news-section mt-5">
            <div class="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
              <h2 class="section-title mb-0">
                Crônicas e Boletins Recentes
              </h2>
              <div class="text-muted small d-flex align-items-center gap-2">
                <i class="bi bi-broadcast"></i>
                Transmitindo de Elysium - {{ newsItems.length }} destaque<span v-if="newsItems.length !== 1">s</span>
              </div>
            </div>
            <div class="row g-4">
              <div class="col-md-6 col-xl-4" v-for="news in newsItems" :key="news.id">
                <article class="card news-card h-100" @click="openNews(news)">
                  <div class="news-card-cover" :style="{ backgroundImage: news.image ? `url(${news.image})` : '' }">
                    <div class="news-card-cover-overlay"></div>
                    <div class="news-card-cover-content">
                      <span class="badge bg-dark text-warning text-uppercase">{{ news.category }}</span>
                      <span class="news-card-date">{{ news.date }}</span>
                    </div>
                  </div>
                  <div class="card-body d-flex flex-column">
                    <h5 class="card-title" style="color: black; font-weight: 600">{{ news.title }}</h5>
                    <p class="card-text text-dark flex-grow-1">{{ news.excerpt }}</p>
                    <div class="mt-3 d-flex flex-wrap gap-2">
                      <span v-for="tag in news.tags" :key="tag" class="badge rounded-pill bg-dark-subtle text-dark">
                        <i class="bi bi-hash me-1"></i>{{ tag }}
                      </span>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </section>

          <section class="mt-5 lore-ticker">
            <div class="lore-card">
              <div class="lore-card-header">
                <h3 class="lore-card-title">
                  <i class="bi bi-calendar3 me-2"></i>
                  Agenda de Eventos Narrativos
                </h3>
                <span class="text-muted small">Sincronize seu coterie</span>
              </div>
              <ul class="lore-timeline list-unstyled mb-0">
                <li v-for="event in upcomingEvents" :key="event.id" class="lore-timeline-item">
                  <div class="lore-timeline-marker"></div>
                  <div class="lore-timeline-content">
                    <div class="d-flex justify-content-between flex-wrap gap-2 mb-1">
                      <strong>{{ event.title }}</strong>
                      <span class="badge bg-dark text-warning">{{ event.date }}</span>
                    </div>
                    <p class="mb-1 small text-muted">{{ event.description }}</p>
                    <div class="small text-uppercase text-warning">{{ event.location }}</div>
                  </div>
                </li>
              </ul>
            </div>
          </section>
        </div>
      </div>

      <!-- Cadastro de Usuário -->
      <PremiumMembershipView v-else-if="currentView === 'membership'" :is-logged-in="isLoggedIn"
        :is-premium-member="isPremiumMember" @cta="handleMembershipCTA" />
      <PremiumCheckoutView v-else-if="currentView === 'checkout'" :user="currentUser" @back="goToMembership"
        @submitted="handleCheckoutSubmitted" />
      <PaymentRedirectView v-else-if="currentView === 'paymentRedirect'" :order-nsu="paymentRedirect.orderNsu"
        :is-logged-in="isLoggedIn" @back="currentView = 'home'" @back-to-profile="goToProfile" @login="promptLogin"
        @status-updated="handlePaymentStatusUpdated" />
      <UserRegistration v-else-if="currentView === 'register'" @registered="handleRegistrationSuccess" />

      <!-- Perfil do Usuário -->
      <UserProfile v-else-if="currentView === 'profile'" :user-id="currentUser ? currentUser.id : null"
        :key="currentUser ? currentUser.id : 'profile'" @updated="handleProfileUpdated" @login-required="promptLogin" />

      <CharacterSheetManager v-else-if="currentView === 'characterSheets'" :user="currentUser"
        @login-required="promptLogin" />

      <ChatView v-else-if="currentView === 'chat'" :current-user="currentUser" />

      <ChroniclesListView v-else-if="currentView === 'chroniclesList'" :current-user="currentUser" />

      <ChronicleCreateEditView v-else-if="currentView === 'chronicleCreate'" :current-user="currentUser"
        :key="'chronicle-create'" />

      <ChronicleCreateEditView v-else-if="currentView === 'chronicleEdit'" :current-user="currentUser"
        :key="$route.params.id || 'chronicle-edit'" />

      <ChronicleDetailView v-else-if="currentView === 'chronicleDetail'" :current-user="currentUser"
        :key="$route.params.id || 'chronicle-detail'" />

      <!-- Visualização de Seita -->
      <div v-else-if="currentView === 'sect'" class="fade-in">
        <SectView :sect="selectedSect" @show-clan-modal="showClanModal" @go-back="currentView = 'home'" />
      </div>

      <!-- Índice de Seitas -->
      <div v-else-if="currentView === 'sectsIndex'" class="fade-in">
        <SectsIndexView @open-info="goToSectInfo" @open-clans="goToSect" />
      </div>

      <!-- Todos os Clãs -->
      <div v-else-if="currentView === 'allClans'" class="fade-in">
        <AllClansView @show-clan-modal="showClanModal" @go-back="currentView = 'home'" />
      </div>

      <!-- Informações da Seita -->
      <div v-else-if="currentView === 'sectInfo'" class="fade-in">
        <SectInfoView :sect="selectedSect" @view-clans="goToSect" @go-back="currentView = 'home'" />
      </div>

      <!-- Visualização de Disciplinas -->
      <div v-else-if="currentView === 'disciplines'" class="fade-in">
        <DisciplinesView @show-discipline-modal="showDisciplineModal" @go-back="currentView = 'home'" />
      </div>

      <!-- Biblioteca de Livros -->
      <div v-else-if="currentView === 'books'" class="fade-in">
        <BooksView @go-back="currentView = 'home'" />
      </div>

      <!-- Jogos e adaptações -->
      <div v-else-if="currentView === 'games'" class="fade-in">
        <GamesView @go-back="currentView = 'home'" />
      </div>

      <!-- Vitrine da Loja -->
      <div v-else-if="currentView === 'store'" class="fade-in">
        <StoreView @go-back="currentView = 'home'" />
      </div>

      <!-- Guia de Regras -->
      <div v-else-if="currentView === 'rules'" class="fade-in">
        <RulesView />
      </div>

      <!-- Forgot Password -->
      <ForgotPassword v-else-if="currentView === 'forgot-password'" />
      <ResetPassword v-else-if="currentView === 'reset-password'" />
    </main>

    <RightSideMenu :is-logged-in="isLoggedIn" @navigate="handleSideMenuNavigate" @logout="logout" />

    <!-- Modal de Login -->
    <div class="modal fade modal-vampire" id="loginModal" tabindex="-1" ref="loginModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="bi bi-box-arrow-in-right me-2"></i>
              Entrar no Mundo das Trevas
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="login">
              <div class="mb-3">
                <label for="loginEmail" class="form-label">Email</label>
                <input type="email" class="form-control" id="loginEmail" v-model="loginForm.email"
                  style="background-color: var(--vampire-gray); border-color: var(--vampire-red); color: #f8f9fa;"
                  required>
              </div>
              <div class="mb-3">
                <label for="loginPassword" class="form-label">Senha</label>
                <input type="password" class="form-control" id="loginPassword" v-model="loginForm.password"
                  style="background-color: var(--vampire-gray); border-color: var(--vampire-red); color: #f8f9fa;"
                  required>
              </div>
              <div v-if="loginError" class="alert alert-danger alert-sm" role="alert">
                {{ loginError }}
              </div>
              <div class="d-grid">
                <button type="submit" class="btn btn-vampire" :disabled="isAuthenticating">
                  <span v-if="isAuthenticating" class="spinner-border spinner-border-sm me-2" role="status"
                    aria-hidden="true"></span>
                  <i v-else class="bi bi-box-arrow-in-right me-2"></i>
                  Entrar
                </button>
              </div>
            </form>
            <div class="text-center mt-3">
              <button type="button" class="btn btn-link text-decoration-none" @click="goToForgotPassword"
                data-bs-dismiss="modal">
                Esqueceu a senha?
              </button>
              <button type="button" class="btn btn-link text-decoration-none" @click="goToRegister"
                data-bs-dismiss="modal">
                Ainda não tem conta? Cadastre-se
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Clã -->
    <ClanModal v-if="selectedClan" :clan="selectedClan" @close="selectedClan = null"
      @open-discipline="openDisciplineFromClan" />

    <!-- Modal de Disciplina -->
    <DisciplineModal v-if="selectedDiscipline" :discipline="selectedDiscipline" @close="selectedDiscipline = null" />
    <NewsModal v-if="selectedNews" :news="selectedNews" @close="selectedNews = null" />
  </div>
</template>

<script>
import { Modal, Collapse } from 'bootstrap'
import SectView from './components/SectView.vue'
import ClanModal from './components/ClanModal.vue'
import DisciplineModal from './components/DisciplineModal.vue'
import DisciplinesView from './components/DisciplinesView.vue'
import BooksView from './components/BooksView.vue'
import GamesView from './components/GamesView.vue'
import StoreView from './components/StoreView.vue'
import RulesView from './components/RulesView.vue'
import SectInfoView from './components/SectInfoView.vue'
import SectsIndexView from './components/SectsIndexView.vue'
import AllClansView from './components/AllClansView.vue'
import RightSideMenu from './components/RightSideMenu.vue'
import UserRegistration from './components/UserRegistration.vue'
import UserProfile from './components/UserProfile.vue'
import CharacterSheetManager from './components/CharacterSheetManager.vue'
import ChatView from './components/ChatView.vue'
import ChroniclesListView from './components/ChroniclesListView.vue'
import ChronicleCreateEditView from './components/ChronicleCreateEditView.vue'
import ChronicleDetailView from './components/ChronicleDetailView.vue'
import ForgotPassword from './components/ForgotPassword.vue'
import ResetPassword from './components/ResetPassword.vue'
import SeoHeadManager from './components/SeoHeadManager.vue'
import { clansData } from './data/clans.js'
import { disciplinesData } from './data/disciplines.js'
import api, { setAuthToken, getStoredToken } from './services/api'
import NewsModal from './components/NewsModal.vue'
import PremiumMembershipView from './components/PremiumMembershipView.vue'
import PremiumCheckoutView from './components/PremiumCheckoutView.vue'
import PaymentRedirectView from './components/PaymentRedirectView.vue'
import VampireConclaveSp from './assets/newsImages/vampire_conclave_sp.png'
import SabbatVaulderieMooca from './assets/newsImages/sabbat_vaulderie_mooca.png'
import AnarchistFestivalPinheiros from './assets/newsImages/anarchist_festival_pinheiros.png'

export default {
  name: 'App',
  components: {
    SectView,
    ClanModal,
    DisciplineModal,
    DisciplinesView,
    BooksView,
    GamesView,
    StoreView,
    RulesView,
    SectInfoView,
    SectsIndexView,
    AllClansView,
    RightSideMenu,
    UserRegistration,
    UserProfile,
    CharacterSheetManager,
    ChatView,
    ChroniclesListView,
    ChronicleCreateEditView,
    ChronicleDetailView,
    SeoHeadManager,
    NewsModal,
    PremiumMembershipView,
    PremiumCheckoutView,
    PaymentRedirectView,
    ForgotPassword,
    ResetPassword
  },
  data() {
    return {
      currentView: 'home',
      selectedSect: null,
      selectedClan: null,
      selectedDiscipline: null,
      isLoggedIn: false,
      showLoginModal: false,
      currentUser: null,
      loginForm: {
        email: '',
        password: ''
      },
      loginError: '',
      isAuthenticating: false,
      registrationSuccessMessage: '',
      postLoginTarget: null,
      selectedNews: null,
      paymentRedirect: {
        orderNsu: ''
      },
      newsItems: [
        {
          id: 'conclave-sp',
          title: 'Conclave emergencial em São Paulo convoca anciões e neonatos influentes',
          category: 'Política Cainita',
          date: '27 Jun 2024',
          excerpt:
            'Rumores de ruptura na Camarilla local após o desaparecimento do primogênito Ventrue. Expectativa de alianças improváveis.',
          tags: ['Camarilla', 'Intriga', 'Elysium'],
          image: VampireConclaveSp,
          body: [
            'O Príncipe Augusto Batista convocou um conclave extraordinário para discutir o súbito desaparecimento de Ana Beatrice, Primógena Ventrue e peça-chave na manutenção da paz com os Anarquistas.',
            'Coteries aliadas à Camarilla relatam movimentações discretas do Sabá nos portos e a presença de antigos caçadores na região central.',
            'Prepare investigações políticas, missões de proteção e jogos de influência social para este arco narrativo.'
          ],
          highlights: [
            'Recomenda-se testes de Política e Investigação para descobrir novas pistas.',
            'NPC destaque: Xerife Helena Duarte, em busca de informantes confiáveis.',
            'Compensação: 2 Pontos de Prestígio para coteries que apresentarem provas relevantes.'
          ]
        },
        {
          id: 'sabbat-ritual',
          title: 'Sabbat anuncia rito de sangue nas ruínas da Mooca',
          category: 'Alerta Sabbat',
          date: '18 Abr 2024',
          excerpt:
            'Espada de Caim planeja ritual de Vaulderie em território contestado. Gangrel independentes relatam presságios.',
          tags: ['Sabbat', 'Conflito', 'Ritual'],
          image: SabbatVaulderieMooca,
          body: [
            'Mensageiros da Espada divulgaram convites para um rito aberto de Vaulderie, evento raro destinado a recrutar novos leais.',
            'O Setita conhecido como “O Alquimista” oferece proteção a quem fornecer informações sobre a logística do ritual.',
            'Narradores podem explorar conflitos morais, infiltrações arriscadas e a tentação do poder sombrio.'
          ],
          highlights: [
            'Teste cenas de infiltração com Furtividade e Ofuscação.',
            'Perigo iminente de Frenesi coletivo caso o rito seja interrompido.',
            'Recompensas incluem acesso temporário a recursos sabbáticos.'
          ]
        },
        {
          id: 'anarch-festival',
          title: 'Festival Anarquista em Pinheiros celebra novos acordos',
          category: 'Movimento Anarquista',
          date: '15 Jan 2024',
          excerpt:
            'Encontro multicultural promete expandir a Rede da Noite. Artistas mortais e vampiros dividem o palco sob proteção da coterie Relâmpago.',
          tags: ['Anarquistas', 'Influência Mortal', 'Arte'],
          image: AnarchistFestivalPinheiros,
          body: [
            'A coterie Relâmpago planeja uma noite de celebração com mortais influentes, buscando fortalecer alianças dentro da cena cultural paulistana.',
            'Boatos indicam que um caçador independente pretende usar o evento para expor segredos da Máscara ao vivo nas redes sociais.',
            'Equilibre cenas sociais, investigação tecnológica e contenção de ameaças para manter o festival em segurança.'
          ],
          highlights: [
            'Desafios com Etiqueta e Performance podem render contatos valiosos.',
            'Perigos de quebra da Máscara exigem criatividade e pensamento rápido.',
            'Possibilidade de desbloquear um Refúgio compartilhado para o grupo.'
          ]
        }
      ],
      upcomingEvents: [
        {
          id: 'elysium-meeting',
          title: 'Elysium Especial – Negociações da Trégua',
          date: '22 Abr',
          description: 'Sessão focada em diplomacia entre Camarilla e Anarquistas, com participação de um Arconte.',
          location: 'Museu do Ipiranga (Elysium)'
        },
        {
          id: 'hunt-night',
          title: 'Caçada Social do Príncipe',
          date: '26 Abr',
          description: 'Evento narrativo aberto para disputar favores do Príncipe em troca de investigações paralelas.',
          location: 'Distrito da Luz'
        },
        {
          id: 'sabbat-strike',
          title: 'Golpe relâmpago do Sabbat',
          date: '03 Mai',
          description: 'Missão opcional de contra-ataque para evitar o avanço da Espada de Caim na Zona Leste.',
          location: 'Ruínas da Mooca'
        }
      ]
    }
  },
  computed: {
    sects() {
      return Object.keys(clansData).map(id => ({ id, name: clansData[id].name }))
    },
    userDisplayName() {
      return this.currentUser && this.currentUser.name ? this.currentUser.name : 'Cainita'
    },
    featuredUpdate() {
      const firstNews = this.newsItems[0]
      return firstNews ? firstNews.date : 'poucos instantes'
    },
    isPremiumMember() {
      const type = (this.currentUser?.account_type || '').toLowerCase()
      return type === 'premium'
    }
  },
  watch: {
    '$route.path': {
      immediate: true,
      handler() {
        this.applyRouteContext()
      }
    },
    showLoginModal(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          const modal = new Modal(this.$refs.loginModal)
          modal.show()
        })
      } else {
        this.$nextTick(() => {
          const modal = Modal.getInstance(this.$refs.loginModal)
          if (modal) {
            modal.hide()
          }
        })
      }
    }
  },
  mounted() {
    const modalElement = this.$refs.loginModal
    if (modalElement) {
      this.loginModalHiddenHandler = () => {
        this.showLoginModal = false
      }
      modalElement.addEventListener('hidden.bs.modal', this.loginModalHiddenHandler)
    }

    this.detectPaymentRedirect()
    this.restoreSessionFromToken()
  },
  beforeUnmount() {
    const modalElement = this.$refs.loginModal
    if (modalElement && this.loginModalHiddenHandler) {
      modalElement.removeEventListener('hidden.bs.modal', this.loginModalHiddenHandler)
    }
  },
  methods: {
    applyRouteContext() {
      const routeMeta = this.$route?.meta || {}
      const targetView = routeMeta.view || 'home'

      if (targetView === 'chat' && (!this.isLoggedIn || !this.currentUser)) {
        this.postLoginTarget = 'chat'
        this.showLoginModal = true
        this.currentView = 'home'
        return
      }

      this.currentView = targetView

      if (routeMeta.clanId) {
        this.focusClanById(routeMeta.clanId)
      } else if (targetView !== 'allClans') {
        this.selectedClan = null
      }

      if (targetView !== 'disciplines') {
        this.selectedDiscipline = null
      }
    },
    navigateTo(path) {
      if (this.$router && typeof this.$router.push === 'function') {
        this.$router.push(path)
      } else if (typeof window !== 'undefined') {
        window.history.pushState({}, '', path)
      }
    },
    findClanById(clanId) {
      if (!clanId) {
        return null
      }

      const sects = Object.values(clansData || {})

      for (const sect of sects) {
        const found = (sect.clans || []).find(clan => clan.id === clanId)
        if (found) {
          return found
        }
      }

      return null
    },
    focusClanById(clanId) {
      const clan = this.findClanById(clanId)
      if (clan) {
        this.selectedClan = clan
        this.currentView = 'allClans'
      }
    },
    detectPaymentRedirect() {
      const params = new URLSearchParams(window.location.search)
      const orderNsu = params.get('order_nsu') || params.get('orderNsu')

      if (orderNsu) {
        this.paymentRedirect.orderNsu = orderNsu
        this.currentView = 'paymentRedirect'
      }
    },
    async restoreSessionFromToken() {
      const token = getStoredToken()
      if (!token) {
        return
      }

      try {
        await this.refreshCurrentUser()
      } catch (error) {
        setAuthToken(null)
        this.isLoggedIn = false
        this.currentUser = null
      }
    },
    async refreshCurrentUser() {
      const { data } = await api.get('/auth/me')
      this.isLoggedIn = true
      this.currentUser = data.user
      this.registrationSuccessMessage = ''
      this.loginError = ''
    },
    closeCollapsedNav() {
      const nav = document.getElementById('navbarNav')
      if (nav && nav.classList.contains('show')) {
        const instance = Collapse.getOrCreateInstance(nav)
        instance.hide()
      }
    },
    selectSect(sectName) {
      this.selectedSect = sectName
      this.currentView = 'sect'
    },

    goToHome() {
      this.navigateTo('/')
      this.closeCollapsedNav()
    },

    goToSect(sectName) {
      this.selectSect(sectName)
      this.closeCollapsedNav()
    },
    goToSectsIndex() {
      this.navigateTo('/seitas')
      this.closeCollapsedNav()
    },
    goToSectInfo(sectName) {
      this.selectedSect = sectName
      this.currentView = 'sectInfo'
      this.closeCollapsedNav()
    },
    goToDisciplines() {
      this.navigateTo('/disciplinas')
      this.closeCollapsedNav()
    },
    goToRules() {
      this.navigateTo('/regras')
      this.closeCollapsedNav()
    },
    goToBooks() {
      this.navigateTo('/livros')
      this.closeCollapsedNav()
    },
    goToGames() {
      this.navigateTo('/jogos')
      this.closeCollapsedNav()
    },
    goToStore() {
      this.navigateTo('/loja')
      this.closeCollapsedNav()
    },
    goToCharacterSheets() {
      this.navigateTo('/ficha-vampiro-a-mascara')
      if (!this.isLoggedIn || !this.currentUser) {
        this.registrationSuccessMessage = ''
        this.showLoginModal = true
        return
      }

      this.currentView = 'characterSheets'
      this.showLoginModal = false
      this.closeCollapsedNav()
    },

    goToForgotPassword() {
      this.navigateTo('/forgot-password');
      const modal = Modal.getInstance(this.$refs.loginModal)
      if (modal) {
        modal.hide()
      }
      this.closeCollapsedNav();
    },
    goToChat() {
      this.navigateTo('/chat')
      if (!this.isLoggedIn || !this.currentUser) {
        this.registrationSuccessMessage = ''
        this.postLoginTarget = 'chat'
        this.loginError = 'Para acessar o chat é necessário estar logado.'
        this.showLoginModal = true
        return
      }

      this.currentView = 'chat'
      this.showLoginModal = false
      this.closeCollapsedNav()
    },
    goToChronicles() {
      this.navigateTo('/cronicas')
      this.currentView = 'chroniclesList'
      this.closeCollapsedNav()
    },
    goToAllClans() {
      this.navigateTo('/clas')
      this.currentView = 'allClans'
      this.closeCollapsedNav()
    },
    goToMembership() {
      this.registrationSuccessMessage = ''
      this.currentView = 'membership'
      this.showLoginModal = false
      this.postLoginTarget = null
      this.closeCollapsedNav()
    },
    goToCheckout() {
      if (!this.isLoggedIn || !this.currentUser) {
        this.registrationSuccessMessage = 'Crie sua conta para finalizar a assinatura Premium.'
        this.postLoginTarget = 'checkout'
        this.currentView = 'register'
        this.showLoginModal = false
        this.closeCollapsedNav()
        return
      }

      if (this.isPremiumMember) {
        this.registrationSuccessMessage = 'Sua conta já está no plano Premium.'
        return
      }

      this.registrationSuccessMessage = ''
      this.currentView = 'checkout'
      this.showLoginModal = false
      this.closeCollapsedNav()
    },
    showClanModal(clan) {
      this.selectedClan = clan
    },
    showDisciplineModal(discipline) {
      this.selectedDiscipline = discipline
    },
    openDisciplineFromClan(name) {
      const found = disciplinesData.find(d => (d.name || '').toLowerCase() === (name || '').toLowerCase())
      if (found) {
        this.selectedClan = null
        this.$nextTick(() => {
          this.selectedDiscipline = found
        })
      }
    },
    async login() {
      if (!this.loginForm.email || !this.loginForm.password) {
        this.loginError = 'Informe email e senha.'
        return
      }

      this.loginError = ''
      this.isAuthenticating = true

      try {
        const { data } = await api.post('/auth/login', {
          email: this.loginForm.email,
          password: this.loginForm.password
        })

        if (data.token) {
          setAuthToken(data.token)
        }

        this.isLoggedIn = true
        this.currentUser = data.user
        this.registrationSuccessMessage = ''
        this.showLoginModal = false

        const modal = Modal.getInstance(this.$refs.loginModal)
        if (modal) {
          modal.hide()
        }

        this.loginForm = { email: '', password: '' }

        if (this.postLoginTarget === 'chat') {
          this.navigateTo('/chat')
          this.currentView = 'chat'
        } else if (this.postLoginTarget === 'checkout') {
          if (this.isPremiumMember) {
            this.currentView = 'membership'
            this.registrationSuccessMessage = 'Sua conta já possui os benefícios Premium ativos.'
          } else {
            this.currentView = 'checkout'
          }
        }
        this.postLoginTarget = null
      } catch (error) {
        this.loginError = error.response?.data?.error || 'Não foi possível realizar o login.'
        setAuthToken(null)
      } finally {
        this.isAuthenticating = false
      }
    },
    logout() {
      const confirmed = window.confirm('Deseja realmente encerrar sua sessão?')
      if (!confirmed) {
        return
      }
      this.performLogout()
    },
    performLogout() {
      setAuthToken(null)
      this.isLoggedIn = false
      this.currentUser = null
      this.navigateTo('/')
      this.currentView = 'home'
      this.registrationSuccessMessage = ''
      this.loginForm = { email: '', password: '' }
      this.postLoginTarget = null
      this.closeCollapsedNav()
    },
    goToRegister() {
      this.registrationSuccessMessage = ''
      this.currentView = 'register'
      this.showLoginModal = false
      this.closeCollapsedNav()
    },
    goToProfile() {
      if (!this.isLoggedIn || !this.currentUser) {
        this.registrationSuccessMessage = ''
        this.showLoginModal = true
        return
      }

      this.currentView = 'profile'
      this.showLoginModal = false
      this.closeCollapsedNav()
    },
    handleRegistrationSuccess(user) {
      this.registrationSuccessMessage = 'Conta criada com sucesso! Faça login com seu email.'
      this.loginForm.email = user.email
      this.loginForm.password = ''
      this.showLoginModal = true
      this.currentView = 'home'
    },
    handleProfileUpdated(user) {
      this.currentUser = user
    },
    handleSideMenuNavigate(target) {
      if (target === 'profile') {
        this.goToProfile()
      } else if (target === 'register') {
        this.goToRegister()
      } else if (target === 'rules') {
        this.goToRules()
      } else if (target === 'books') {
        this.goToBooks()
      } else if (target === 'games') {
        this.goToGames()
      } else if (target === 'store') {
        this.goToStore()
      } else if (target === 'characterSheets') {
        this.goToCharacterSheets()
      } else if (target === 'chat') {
        this.goToChat()
      } else if (target === 'membership') {
        this.goToMembership()
      } else if (target === 'checkout') {
        this.handleMembershipCTA()
      }
    },
    promptLogin() {
      this.showLoginModal = true
    },
    handleMembershipCTA() {
      if (this.isPremiumMember) {
        this.registrationSuccessMessage = 'Sua conta já é Premium. Aproveite os recursos exclusivos!'
        return
      }

      this.goToCheckout()
    },
    handleCheckoutSubmitted(response) {
      if (!response) {
        this.registrationSuccessMessage = 'Solicitação registrada! Em breve entraremos em contato.'
        return
      }

      if (response.delivered === false && response.reason) {
        this.registrationSuccessMessage = `Solicitação registrada, mas ${response.reason}`
      } else {
        this.registrationSuccessMessage = 'Solicitação registrada! Você receberá instruções no seu e-mail.'
      }
    },
    async handlePaymentStatusUpdated(status) {
      if (status !== 'paid') {
        return
      }

      try {
        await this.refreshCurrentUser()
        this.registrationSuccessMessage = 'Pagamento confirmado! Seu plano Premium será ativado na conta.'
      } catch (error) {
        console.error('Não foi possível atualizar o usuário após pagamento', error)
      }
    },
    openNews(news) {
      if (!news) {
        return
      }
      this.selectedNews = news
    }
  }
}
</script>

<style>
.alert-vampire {
  background: rgba(26, 26, 26, 0.92);
  border: 1px solid rgba(218, 165, 32, 0.3);
  color: #f8f9fa;
  box-shadow: 0 0 18px rgba(139, 0, 0, 0.2);
}

.alert-vampire.alert-success {
  border-color: rgba(218, 165, 32, 0.45);
}

.alert-sm {
  padding: 0.5rem 0.75rem;
  font-size: 0.9rem;
}

.hero-section {
  margin-top: 1rem;
}

.eyebrow {
  letter-spacing: 0.28em;
  font-size: 0.75rem;
  color: var(--vampire-gold);
}

.text-muted-hero {
  color: rgba(233, 236, 239, 0.82) !important;
}

.nightfall-card {
  background: rgba(18, 18, 18, 0.85);
  border: 1px solid rgba(218, 165, 32, 0.2);
  border-radius: 1rem;
  padding: 1.75rem;
  box-shadow: 0 10px 35px rgba(0, 0, 0, 0.45);
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.nightfall-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  color: rgba(233, 236, 239, 0.7);
}

.nightfall-card-title {
  font-size: 1.15rem;
  font-weight: 600;
  color: #f8f9fa;
}

.news-section .section-title {
  font-size: 1.6rem;
  font-weight: 600;
  color: #f8f9fa;
}

.news-card {
  background: rgba(248, 249, 250, 0.88);
  border: 1px solid rgba(218, 165, 32, 0.15);
  border-radius: 1rem;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.news-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 18px 35px rgba(0, 0, 0, 0.45);
}

.news-card-cover {
  position: relative;
  min-height: 160px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.news-card-cover-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(0, 0, 0, 0.75) 0%, rgba(139, 0, 0, 0.45) 100%);
}

.news-card-cover-content {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1.25rem;
}

.news-card-date {
  color: rgba(233, 236, 239, 0.85);
  font-size: 0.85rem;
}

.lore-ticker {
  display: flex;
}

.lore-card {
  background: rgba(18, 18, 18, 0.82);
  border: 1px solid rgba(218, 165, 32, 0.2);
  border-radius: 1rem;
  padding: 1.75rem;
  width: 100%;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.35);
}

.lore-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.lore-card-title {
  margin: 0;
  font-size: 1.3rem;
  color: #f8f9fa;
}

.lore-timeline {
  position: relative;
  padding-left: 1.5rem;
}

.lore-timeline::before {
  content: '';
  position: absolute;
  top: 0.25rem;
  bottom: 0.25rem;
  left: 0.45rem;
  width: 2px;
  background: linear-gradient(180deg, rgba(218, 165, 32, 0.6), rgba(139, 0, 0, 0.6));
}

.lore-timeline-item {
  position: relative;
  margin-bottom: 1.25rem;
  padding-left: 1rem;
}

.lore-timeline-item:last-child {
  margin-bottom: 0;
}

.lore-timeline-marker {
  position: absolute;
  left: -1.05rem;
  top: 0.35rem;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: var(--vampire-gold);
  box-shadow: 0 0 0 3px rgba(218, 165, 32, 0.25);
}

.lore-timeline-content {
  background: rgba(26, 26, 26, 0.7);
  border: 1px solid rgba(218, 165, 32, 0.15);
  border-radius: 0.75rem;
  padding: 1rem;
}

.bg-danger-subtle {
  background-color: rgba(139, 0, 0, 0.25) !important;
  color: #f8f9fa !important;
}

.bg-secondary-subtle {
  background-color: rgba(108, 117, 125, 0.25) !important;
  color: #f8f9fa !important;
}

@media (max-width: 992px) {
  .nightfall-card {
    padding: 1.5rem;
  }

  .lore-card {
    padding: 1.5rem;
  }
}

@media (max-width: 768px) {
  .hero-section {
    text-align: center;
  }

  .nightfall-card-header {
    flex-direction: column;
  }

  .nightfall-card {
    align-items: center;
  }

  .news-card {
    margin-bottom: 0.5rem;
  }

  .lore-card-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .lore-timeline {
    padding-left: 1rem;
  }
}
</style>
